import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateMe, UpdateMeRequest } from "@/api";
import { useUIStore } from "@/stores";

const useUpdateMe = ({ successMsg }: { successMsg?: string }) => {
  const queryClient = useQueryClient();
  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: UpdateMeRequest) => {
      return updateMe(body);
    },
    onSuccess: async (profile) => {
      await queryClient.setQueryData(["my-user"], () => profile);
      if (successMsg) {
        openToast({ variant: "success", message: successMsg });
      }
    },
  });
};

export { useUpdateMe };
